<template>
  <div class="container flex-centered display-column justify-space-around">
    <div class="title">
      {{ $t('auth.register.success.title') }}
    </div>
    <div class="subtitle">
      {{ $t('auth.register.success.subtitle') }}
    </div>

    <vv-button
      @click="resendConfirmationCode"
      :isLoading="isLoading"
      customClass="primary-variant"
    >{{ $t('auth.register.resendConfirmationCode')}}</vv-button>
    <span v-if="success">{{ $t('auth.resendConfirmationCodeSuccess') }}</span>
    <span v-if="error">{{ $t(error) }}</span>

    <img src="@/assets/crea-compte@2x.png" />
  </div>
</template>

<script>
import VvButton from '@/components/common/VvButton'
import { RESEND_CONFIRMATION_CODE } from '@/store/modules/user/types'

export default {
  name: 'ConfirmRegistration',
  components: {
    VvButton
  },
  data: () => ({
    isLoading: false,
    success: false,
    error: false
  }),
  computed: {
    registeringUser() {
      return this.$store.state.user.registeringUser
    }
  },
  methods: {
    async resendConfirmationCode() {
      this.isLoading = true
      this.error = false
      this.success = false

      const [error, response] = await this.$store.dispatch(RESEND_CONFIRMATION_CODE,{
        destinataire: this.user.firstname ? this.user.firstname : "",
        email: this.user.email
      })


      if (error || response.data.error) {
        if (error && error.code) {
          this.error = error.code
        } else if (response.data.error) {
          this.error = response.data.reason
        } else {
          this.error = 'custom/internal-error'
        }
      } else {
        this.success = true
        this.isLoading = false
      }

      this.isLoading = false
    }
  },
  mounted() {
    if (!this.registeringUser) {
      this.$router.push('Home')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/_variables.scss';

  .container {
    margin-top: 50px;

    .title {
      font-family: Helvetica, sans-serif;
      font-size: 2.2rem;
      color: $primary;
      margin-bottom: 5px;
      text-align: center;
    }

    .subtitle {
      font-size: 1.55rem;
      font-weight: bold;
      margin-bottom: 30px;
      text-align: center;
    }

    button {
      margin-bottom: 30px;
    }

    img {
      width: 300px;
    }
  }
</style>
